import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

const useStyle = makeStyles((theme: Theme) => ({
    preisBubble: {
        "&::before, &::after": {
            content: '""',
            position: 'absolute',
            display: 'block',
            top: -22,
            left: 59,
            width: 0,
            height: 0,
            border: 'solid 20px transparent',
            borderTop: 0,
            transform: 'scaleX(-0.3) scaleY(1.4)',
            borderBottomColor: '#ffffff',
            zIndex: 2
        },
        "&::before":{
            top: -15,
            left: 59,
            zIndex: 3,
            borderBottomColor: 'rgba(0,159,109,1)',
            transform: 'scaleX(0.2) scaleY(1.0)'
        },
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        background: 'linear-gradient(180deg, rgba(0,159,109,1) 0%, rgba(28,96,68,1) 100%)',
        color: '#ffffff',
        border: '3px solid #ffffff', 
        height: 200,
        width: 200,
        display: 'flex', 
        flexDirection: 'column',
        zIndex: 0, 
        transform: 'rotate(-17deg)', 
        padding: 5, 
        alignItems: 'center', 
        justifyContent: 'center', 
        textAlign: 'center', 
        position: 'absolute', 
        top: 111, 
        left: 8,
    },
}));


export const PreisBubble: React.FC = () => {
    const classes = useStyle();

    return (
        <Box className={classes.preisBubble}>
            <Typography variant='h5'>Unser<br />bissiger Preis:<br />schon ab</Typography>
            <Typography variant='subtitle1' style={{fontSize: 38, padding: 0, marginTop: -10, marginBottom: -10, letterSpacing: 'initial'}}>5,36€</Typography>
            <Typography variant='h6'>im Monat*</Typography>
        </Box>
    );
}